import {Watch} from '@acng/frontend-relativity';
import {Engine, ElementSetup} from '@acng/frontend-stargazer';
import {
  HTMLElement,
  connectedCallback,
  defineElement,
  disconnectedCallback,
} from '@acng/frontend-bounty/dom/custom.js';
import {ctxAmateur} from '../context/amateur.js';
import {append, createElement, removeChildNodes, setText} from '@acng/frontend-bounty';
import {inject} from 'acng/core/service/ng.js';

/**
 * @group DOM Element
 */
const AMATEUR_LABEL = 'onsw-amateur-label';

ElementSetup(AMATEUR_LABEL, (name) => {
  const watch = Watch(name, ctxAmateur);
  const transclude = Engine.Transclude(name);

  defineElement(
    name,
    class extends HTMLElement {
      #engine = Engine.root;

      [connectedCallback]() {
        this.#engine = transclude(this);

        watch(this, (element, amateur) => {
          if (!amateur) {
            removeChildNodes(element);
            return;
          }

          this.#engine.toElement(
            element,
            {
              nickname: amateur.getNickname(),
              age: amateur.age,
              description: amateur.getDescription(),
            },
            (nodes) => {
              const node = nodes.from;
              if (node) {
                setText(node, '');
                if (!inject('user').isInternational()) {
                  amateur.getLocation().then((from) => {
                    setText(node, from);
                  });
                }
              }
            }
          );
        });
      }

      [disconnectedCallback]() {
        this.#engine.disconnect();
      }
    }
  );
});
